import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    district,
    province,
    address,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    organizationName,
    taxId2,
    district2,
    province2,
    address2,
    phone2,
    fax2,
    email2,
    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [organizationName.name]: "",
  [address.name]: "",
  [address2.name]: "",
  [email.name]: "",
  [phone.name]: "",
  [fax.name]: "",
  [email2.name]: "",
  [phone2.name]: "",
  [fax2.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId1.name]: "",
  [taxId2.name]: "",
  [taxpayerName.name]: "",
  [district.name]: "",
  [province.name]: "",
  [district2.name]: "",
  [province2.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
